import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectTheme, setTheme } from "../../features/theme/ThemeSlice";

const ThemeToggle = () => {
  const theme = useAppSelector<boolean>(selectTheme);
  const dispatch = useAppDispatch();

  return (
    <div className="custom-control custom-switch">
      <input
        onChange={() => dispatch(setTheme(!theme))}
        type="checkbox"
        className="custom-control-input"
        id="customSwitch1"
        checked={theme}
      />
      <label className="custom-control-label" htmlFor="customSwitch1">
        <i className="icon-light" />
        <i className="icon-dark" />
      </label>
    </div>
  );
};

export default ThemeToggle;
